import { render } from "./ModuleUnderDevelopment.vue?vue&type=template&id=f27c9330&scoped=true"
import script from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"
export * from "./ModuleUnderDevelopment.vue?vue&type=script&lang=js"

import "./ModuleUnderDevelopment.vue?vue&type=style&index=0&id=f27c9330&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27c9330"]])

export default __exports__